export enum C4gPaymentTypes {
  earning = 'earning',
  earningFromPenalty = 'earningFromPenalty'
}
